/**
 * @author        quanquan
 * @dateTime      2020-08-18 14:13:55
 * @description   global params
 */

import Vue from 'vue'
// import store from '@/conf/home/store'
// import TMap from './TMap'
import { checkIp } from '@/module/utils'
import io, { serverAlias, ioUploadImg, apiVersion } from '@/module/io'
// const pinganImgUrl = !process.env.PING_AN_OSS ? 'https://oceanus.jk.cn/hd-oms/' : process.env.PING_AN_OSS
const pinganImgUrl = process.env.PING_AN_OSS
// 生产资源地址 随机取模 images、files
// global.ossProDomain = () => _.sample([`//img.hydee.cn/`, `//img01.hydee.cn/`, `//img02.hydee.cn/`])
global.ossProDomain = pinganImgUrl
// 非生产资源地址
global.ossNoProDomain = () => pinganImgUrl

// 图片域
global.domainImg = () => {
  return global_env === 'production'
    ? (checkIp(window.location.hostname)
      ? `//${window.location.host}/oss-images/`
      : global.ossProDomain)
    : global.ossNoProDomain()
}

// 是否ip访问
global.isIp = checkIp(window.location.hostname)

// 环境变量编译
global.env = global_env

// 环境变量包含本地标记
global.isLocal = global_isLocal // eslint-disable-line

// io请求类
global.io = io

// io上传图片
global.ioUploadImg = ioUploadImg

// 全局api地址
global.apiPrefix = process.env.NODE_ENV === 'production' ? '/businesses-gateway' : '/api'

// 别名服务
global.serverAlias = serverAlias

// api 版本
global.apiVersion = apiVersion

// 上传图片
global.uploadFileURL = `${global.apiPrefix}/${global.serverAlias.merchant}`

// 帮助中心跳转域名
global.helpToDomain = `${global.env === 'production' ? '//help.hydee.cn/' : `//help.${global.env}.ydjia.cn/`}`

// 手动设置选中路由
global.activeRoute = (url) => {
  // store.commit('common/setSelectRoute', url)
}

// 图片地址
global.showImg = function (url) {
  const oss = (t, protocol = 'https') => `${protocol}://centermerchant-${t}.oss-cn-shanghai.aliyuncs.com/`

  if (url) {
    if ((url.indexOf('https') !== -1 || url.indexOf('http') !== -1)) {
      // if (url.startsWith('https://images.ydjia.cn/')) { // 开发环境
      //   return url
      // } else
      if (url.startsWith(pinganImgUrl)) {
        return url
      } else if (url.startsWith('https://ydj-prod-1.oss-cn-shanghai.aliyuncs.com/')) {
        return url
        // 解析成 https://centermerchant-prod.oss-cn-shanghai.aliyuncs.com/ => [`//img.hydee.cn/`, `//img01.hydee.cn/`, `//img02.hydee.cn/`]
      } else if (url.startsWith(oss('test'))) {
        return _.replace(url, oss('test'), global.ossNoProDomain())
        // 解析成 https://centermerchant-prod.oss-cn-shanghai.aliyuncs.com/ => [`//img.hydee.cn/`, `//img01.hydee.cn/`, `//img02.hydee.cn/`]
      } else if (url.startsWith(oss('prod'))) {
        return _.replace(url, oss('prod'), global.ossProDomain)
      } else if (url.startsWith(oss('test', 'http'))) {
        return _.replace(url, oss('test', 'http'), global.ossNoProDomain())
        // 解析成 https://centermerchant-prod.oss-cn-shanghai.aliyuncs.com/ => [`//img.hydee.cn/`, `//img01.hydee.cn/`, `//img02.hydee.cn/`]
      } else if (url.startsWith(oss('prod', 'http'))) {
        return _.replace(url, oss('prod', 'http'), global.ossProDomain)
      } else {
        return url.startsWith('https:')
          ? _.replace(url, 'https:', '')
          : _.replace(url, 'http:', '')
      }
    } else {
      if (url.startsWith(pinganImgUrl) || url.startsWith('//img01.hydee.cn/') || url.startsWith('//img02.hydee.cn/') || url.startsWith(`//images.ydjia.cn/`)) {
        return `${url}`
      } else {
        return (checkIp(window.location.hostname) && global_env === 'production')
          ? `//${window.location.host}/oss-images/${url}`
          : `${global.domainImg()}${url}`
      }
    }
  } else {
    return ''
  }
}

global.showImg2 = function (url) {
  if (_.isEmpty(url)) {
    return ''
  }
  if (url.startsWith('http')) {
    return url
  } else {
    return `${pinganImgUrl}${url}`
  }
}

global.cdnImg = function (url, params) {
  if (_.isEmpty(url)) {
    return ''
  }
  let str = ''
  if (!_.isEmpty(params)) {
    for (const k in params) {
      str += `,${k}_${params[k]}`
    }
  }
  if (url.startsWith('http')) {
    return url
  } else {
    return _.isEmpty(params) ? `${global.domainImg()}${url}` : `${global.domainImg()}${url}?x-oss-process=image/resize${str}`
  }
}

// 下载模板
global.downTpl = function (url, env) {
  // if (env) {
  //   return env === 'prod' ? `${global.ossProDomain}template/${url}` : `${global.ossNoProDomain()}template/${url}`
  // } else {
  //   return global_env === 'production' ? `${global.ossProDomain}template/${url}` : `${global.ossNoProDomain()}template/${url}`
  // }
  return `${global.ossProDomain}template/${url}`
}

// 图片挂载原型
Vue.prototype.showImg = global.showImg
Vue.prototype.showImg2 = global.showImg2
Vue.prototype.cdnImg = global.cdnImg
// 下载模板挂载原型
Vue.prototype.downTpl = global.downTpl

// 腾讯地图
// global.HDTMap = TMap

// 删除指定tagView
global.removeTagView = () => {

}



// WEBPACK FOOTER //
// ./src/js/module/global/index.js